module.exports = __webpack_public_path__ + "a503b8bcd2a33bb70637001dcfceba0b.png";